/**
 * Modèle représentant la progression d'un traitement back
 *
 * @author Laurent Convert
 * @date 01/08/2025
 */
export class Progression {
	nbSuccess: number;
	nbTraites: number;
	nbTotal: number;
	progression: number;
	complete: boolean;
	uuid?: string;
	etape?: Etape;

	/**
	 * Constructeur
	 *
	 * @param dto Source
	 */
	constructor(dto?: Progression) {
		if (dto) {
			Object.assign(this,dto);
		}
	}

	/**
	 * Calcul le pourcentage d'avancement arrondi à 2 décimales
	 */
	public computeProgression?() {
		this.progression = this.nbTotal > 0 ? Math.max(0,Math.min(100,Math.round(((this.nbTraites ?? 0) * 100 / this.nbTotal) * 100) / 100)) : 0;
	}
}

/**
 * Énumération des différentes étapes
 */
export enum Etape {
	EXECUTION = 'EXECUTION',
	IMPUTATION = 'IMPUTATION',
	SYNCHRO_WF = 'SYNCHRO_WF',
}